<template>
    <router-view></router-view>
</template>

<script>
export default {
	name: 'page-configuration',
};
</script>





// WEBPACK FOOTER //
// src/pages/configuration/page-configuration.vue